<template>
    <component :is="barToShow" />

    <v-main class="tw-bg-white">
        <PostsLoader>
            <ioAlert />
            <router-view v-slot="{ Component }">
                <keep-alive>
                    <component :is="Component" />
                </keep-alive>
            </router-view>
        </PostsLoader>
    </v-main>

    <BottomBar />
</template>

<script lang="ts" setup>
    import Navbar from './Navbar.vue';
    import ioAlert from '@/components/ioAlert.vue';
    import BottomBar from '@/views/BottomBar.vue';
    import PostsLoader from './PostsLoader.vue';

    const $route = useRoute();

    const barToShow = computed(() => {
        // check if the current route has the meta property 'navbar'
        return $route.meta.navbar || Navbar;
    });
</script>
